export const getFinancialTextColor = (score) => {
  if (score < 35) return 'highly-unlikely'
  if (score < 45) return 'unlikely'
  if (score < 65) return 'possibly'
  if (score < 75) return 'likely'
  return 'highly-likely'
}
